import { ObjectWith } from '../../../cross-team-shared/types/misc';
import { ContentConnector } from '../../../team-apis/content/content-connector';
import { EventTrackingValue } from '../../../team-apis/core/event-tracking';

export function updateExtrapolationsForShapes(
  shapeIndices: number[],
  getContentConnector: (shapeIndex: number) => ContentConnector,
  frameNumber: number,
) {
  const extrapolatedFramesCounts: ObjectWith<number | undefined> = {};

  shapeIndices.forEach((shapeIndex) => {
    extrapolatedFramesCounts[shapeIndex] = getContentConnector(
      shapeIndex,
    ).updateExtrapolation(shapeIndex, frameNumber);
  });

  return extrapolatedFramesCounts;
}

export function getMlExtrapolationEventTrackingValues(
  requestedExtrapolatedFramesCounts: ObjectWith<number | undefined>,
  shapes: EventTrackingValue[],
) {
  return shapes.map((shape) => {
    const count = requestedExtrapolatedFramesCounts[shape.index];
    if (count === undefined) {
      return shape;
    }
    return {
      ...shape,
      requested_extrapolated_frames_count: count,
    };
  });
}
